import React, { useEffect, useState } from 'react'
import { Button, Grid, Typography } from '@mui/material'
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import Sidebar from './components/Sidebar';
import i18next from 'i18next';
import { useLocation, useNavigate } from 'react-router';
import PersonIcon from '@mui/icons-material/Person';
import PeopleIcon from '@mui/icons-material/People';
import InsightsIcon from '@mui/icons-material/Insights';
import { ThreeDots } from "react-loader-spinner";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import OfflineBoltIcon from "@mui/icons-material/OfflineBolt";
import moment from "moment/moment";
import MainLoader from './components/MainLoader';
import { serviceDown } from './utils/UtilityFunctions';
import { postApi } from './api/services';
import swal from 'sweetalert';

const PatientInsights = () => {

  const navigate = useNavigate()
  const location = useLocation()
  const [isLoading, setIsLoading] = useState(false)
  const [patientInsights, setPatientInsights] = useState({})
  const [reportList, setReportList] = useState([
    {
      id: 1,
      patientName: "Alice Johnson",
      reportId: "RPT12345",
      current_stage: "VALIDATOR_1_ASSIGNED",
      status: "AI_GENERATED",
      date: "2023-10-01"
    },
    {
      id: 2,
      patientName: "Jane Smith",
      reportId: "RPT12346",
      current_stage: "VALIDATOR_1_COMPLETED",
      status: "In Progress",
      date: "2023-10-01"
    },
    {
      id: 3,
      patientName: "Tom Brown",
      reportId: "RPT12347",
      current_stage: "VALIDATOR_2_COMPLETED",
      status: "Completed",
      date: "2023-10-01"
    },
    {
      id: 4,
      patientName: "John Doe",
      reportId: "RPT12348",
      current_stage: "AI_GENERATED",
      status: "In Progress",
      date: "2023-10-01"
    },
    {
      id: 5,
      patientName: "Bob White",
      reportId: "RPT12349",
      current_stage: "VALIDATOR_2_COMPLETED",
      status: "Rejected",
      date: "2023-10-01"
    },
  ])

  useEffect(() => {
    getReportsList()
  }, [])

  const getReportsList = async () => {
    let params = {
      // doctor_id: localStorage.getItem('doctorobj')?.doctor_id
      doctor_id: 19
    }
    console.log('get_hair_analysis_status_by_doctor params', params); 
    try{
      setIsLoading(true)
      let res = await postApi('get_hair_analysis_status_by_doctor', params)
      if(res){
        console.log('get_hair_analysis_status_by_doctor res', res);
        setPatientInsights(res)
        setIsLoading(false) 
      }
    } catch(err) {
      console.log("err", err);
      // await trackEvent('check_user', 'fail', err, localStorage.getItem('phno'))
      setIsLoading(false)
      serviceDown('/loginpage') 
    }
  }

  const goToReport = (report) => {
    console.log("goToReport", report);
    if(report.current_stage === "AI_GENERATED"){
      // getAiReportDetails(report.analysis_id)
      navigate("/resultnew", { state: { analysis_id: report.analysis_id, current_stage: report.current_stage, gender: report.gender}});
    } else {
      if (report.status == "Completed") {
        // localStorage.setItem('report_analysis_id', JSON.stringify(report.analysis_id))
        navigate("/resultnew", { state: { analysis_id: report.analysis_id, current_stage: report.current_stage, gender: report.gender}});
      } else if (report.status === "Rejected") {
        getReportDetails(report.analysis_id);
      } else {
        swal({
          title: `Your report is ${report.status.toLowerCase()}`,
        });
      }
    }
  };

  const getReportDetails = async (id) => {
    try {
      setIsLoading(true);
      let apiobj = {
        analysis_id: id,
      };
      console.log("get_hair_analysis_report params", apiobj);
      const data = await postApi('get_hair_analysis_report', apiobj)
      if (data) {
        console.log("get_hair_analysis_report res", data);
        setIsLoading(false);
        swal({
          title: `${i18next.t("Report is invalid")}`,
          text: `${i18next.t("Reason")} : ${data?.report?.final_comments}`,
        });
      }
    } catch (err) {
      console.log("err", err);
      setIsLoading(false)
      serviceDown()
    }
  };

  return (
    <>
      {isLoading && <MainLoader/>}
      <div className='patientInsightsPage photo-container main-section-container'>
        <Grid container spacing={0} className='d-flex justify-content-start align-items-center'>
          <Grid item xs={1} className=''>
            {/* {
              location?.state?.from &&  */}
                <div className='d-flex justify-content-start align-items-center'>
                  <span className='backButtonDiv' onClick={() => navigate(-1)}>
                    <ArrowBackOutlinedIcon className='arrowBackBtn'></ArrowBackOutlinedIcon>
                  </span>
                </div>
            {/* } */}
          </Grid>
          <Grid item xs={10} className='d-flex justify-content-center align-items-center'>
            <Typography variant="h6" className="title">{i18next.t("Patient Insights")}</Typography>
          </Grid>
          <Grid item xs={1} className='d-flex justify-content-center align-items-center'>
            <Sidebar/>
          </Grid>
        </Grid>
        <div className='patientInsightsPage-container'>
          <Grid container spacing={0} className='d-flex justify-content-start align-items-center newpatientcard'>
            <Grid item xs={12} className='d-flex align-items-start flex-direction-column'>
              <h4>{i18next.t("Start New Patient Report")}</h4>
              {/* <p>{i18next.t("Complete assessment in under 3 minutes")}</p> */}
              <Button onClick={() => navigate('/clientregistration')} variant="contained" className='addPatientBtn'>
                {i18next.t("Add Patient")}
              </Button>
            </Grid>
          </Grid>
          <Grid container spacing={0} className='d-flex justify-content-start align-items-center casescard'>
            <Grid item xs={12} className='d-flex align-items-start justify-content-center'>
              <Grid item xs={6} className='d-flex align-items-start justify-content-center '>
                <Grid item xs={12} className='d-flex align-items-center justify-content-center caseCard first'>
                  <Grid item xs={4} className='d-flex align-items-center justify-content-center'>
                    <PeopleIcon/>
                  </Grid>
                  <Grid item xs={8} className='d-flex align-items-start justify-content-center flex-direction-column'>
                    <p className='caseHeading'>{i18next.t("Today's Reports")}</p>
                    <h4 className='caseCount'>{patientInsights?.current_day_count}</h4>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6} className='d-flex align-items-start justify-content-center'>
                <Grid item xs={12} className='d-flex align-items-center justify-content-center caseCard second'>
                  <Grid item xs={4} className='d-flex align-items-center justify-content-center'>
                    <InsightsIcon/>
                  </Grid>
                  <Grid item xs={8} className='d-flex align-items-start justify-content-center flex-direction-column'>
                    <p className='caseHeading'>{i18next.t("This Week")}</p>
                    <h4 className='caseCount'>{patientInsights?.current_week_count}</h4>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container spacing={0} className='d-flex justify-content-start align-items-center casescard patient'>
            <Grid item xs={12} className='d-flex align-items-center justify-content-space-between'>
              <h4>{i18next.t("Recent Reports")}</h4>
              <p className='text-decoration-underline cursor-pointer' onClick={() => navigate('/clients')}>{i18next.t("View All")}</p>
            </Grid>
            <Grid item xs={12} className='patientListDiv'>
              {
                patientInsights.reports?.length > 0 && patientInsights.reports.map((report, index) => {
                  return(
                    <div className='patientcardparentdiv' onClick={() => goToReport(report)}>
                      <Grid item xs={12} className='d-flex align-items-center justify-content-center patientCard cursor-pointer' key={index}>
                        <Grid item xs={2} className='d-flex align-items-center justify-content-center'>
                          <PersonIcon className='personIcon'/>
                        </Grid>
                        <Grid item xs={7} className='d-flex align-items-start justify-content-center flex-direction-column'>
                          <p className='patientName'>
                            {i18next.t((report?.first_name && report?.last_name) ? report.first_name + " " + report.last_name : "NA")}
                          </p>
                          <p className='patientReportId'>{i18next.t(report?.report_id)}</p>
                          <p className='patientInfo'>{i18next.t(moment(report?.analysis_time).format("LL"))}</p>
                        </Grid>
                        {
                          report.current_stage === "VALIDATOR_2_COMPLETED" && report.status != "Rejected" ? 
                          (
                            <Grid item xs={3} className="statusReportDiv completed">
                              <CheckCircleIcon />
                              <Typography className="completedTxt">
                                {i18next.t(`Stage ${report?.norwoodstage}`)}
                              </Typography>
                            </Grid>
                          ) : (report.current_stage === "AI_GENERATED" ||report.current_stage === "VALIDATOR_1_COMPLETED") && report.status != "Rejected" ? 
                          (
                            <Grid item xs={3} className="statusReportDiv quickreport">
                              <OfflineBoltIcon />
                              <Typography className="quickreportTxt">
                                {}
                                {i18next.t(`Stage ${report?.norwoodstage}`)}
                              </Typography>
                            </Grid>
                          ) : (report.current_stage === "AI_GENERATED" || report.current_stage === "VALIDATOR_1_ASSIGNED") && report.status != "Rejected" ? 
                          (
                            <Grid item xs={3} className="statusReportDiv generating">
                              <ThreeDots
                                visible={true}
                                height="20"
                                width="25"
                                color="red"
                                radius="9"
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                              />
                              <Typography className="generatingDiv">
                                {report.status === "Completed"
                                  ? i18next.t("Report")
                                  : "In Progress"}
                              </Typography>
                            </Grid>
                          ) : report.status === "Rejected" ? 
                          (
                            <Grid item xs={3} className="statusReportDiv rejectDiv">
                              <CancelIcon />
                              <Typography className="rejectTxt">
                                {i18next.t("Invalid")}
                              </Typography>
                            </Grid>
                          ) : (
                            ""
                          )
                        }
                      </Grid>
                    </div>
                  )
                })
              }        
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  )
}

export default PatientInsights